import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';
import { AdminPanelReport } from './adminPanel.slice';

const selectAdminPanel = (state: RootState) => state.adminPanel;

const selectReport = createSelector(selectAdminPanel, (items): AdminPanelReport => items.report);

export const adminPanelSelectors = { selectReport };
